module.exports = __webpack_public_path__ + "src/assets/images/hp-bg.png?340538d8f541975e8290487699e9c9c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hp-bg.png
// module id = 995
// module chunks = 1